import * as React from 'react';
import { connect } from 'react-redux';
import { Card } from 'react-bootstrap';
import NotificationBadge from 'react-notification-badge';
import './ClaimsCard.css';
import { setSelectedClaim } from '../../../actions/profileActions';
import { navigateTo } from '../../../actions/navigationActions';

class ClaimsCard extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    async handleClick(id) {
        this.props.dispatcSetSelectedClaim(id);
    }

    getClaimStatusClass(claimStatus) {
        let cssClass = '';
        switch (claimStatus.toLowerCase()) {
            case 'approved':
                cssClass = 'Approved' 
                break;
            case 'in progress':
                cssClass = 'Pending';
                break;
            case 'claim closed':
            case 'claim not authorised':
            case 'claim cancelled (internal kp error)':
                cssClass = 'Cancelled';
                break;
            default: cssClass = 'hidden';
        }
        return cssClass;
    }

    render() {
        let statusClass = this.getClaimStatusClass(this.props.claimStatus);

        return (
            <>
                <div className="Claim-card" id={"ClaimCard"+this.props.id}>
                    <Card className={(this.props.id === this.props.profile.selectedPersonalClaim.claimNumber ? 'isClicked ' : '') + " tile"} onClick={() => this.handleClick(this.props.id)}>
                        <Card.Body>
                            <div className="container">
                            <div className="row">
                                <div className="col-10">
                                    <div className="row mt-2">
                                        <div className="col-12 px-0">
                                            <p className="mb-0"><b>{this.props.headerText}</b></p>
                                            <div className="notifcationBadge">
                                                <NotificationBadge count={parseInt(this.props.alertCount)} />
                                            </div>
                                        </div>
                                            <span className="content">{this.props.bodyText}</span>
                                     </div>

                                    </div>
                                    <div className="col-2">
                                        <div className={'dot float-right ' + statusClass}></div>
                                    </div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatcSetSelectedClaim: (id) => dispatch(setSelectedClaim(id)),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimsCard);